import loadable from '@wix/yoshi-flow-editor/loadable';

export const EmojiPicker = loadable(
  () => import(/* webpackChunkName: "EmojiPicker" */ './EmojiPicker'),
  {
    resolveComponent: (component) => component.EmojiPicker,
  },
);
